module.exports = __webpack_public_path__ + "img/Misi3-3-3Judul0.d0294154.png";